
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.795 4.23L7.966 7.056 5.138 4.23l-.943.943L7.023 8l-2.828 2.828.943.943 2.828-2.828 2.829 2.828.942-.943L8.91 8l2.828-2.828-.942-.943z","fill":"#7E8186"}})])
          )
        }
      }
    